module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/87c98d386b3f4423fc82ecec23ca4f16.png";